"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns an object with the correct argument-string for every integrated Reco-Engine which is used to query the graphQL service
 * @param rdeArguments Arguments that are needed for a specific query. Eg. articleNo for alternativeProducts
 */
var getQueryArguments = function (rdeArguments, locale) {
    var cid = rdeArguments.cid, articleNo = rdeArguments.articleNo, brand = rdeArguments.brand, price = rdeArguments.price, available = rdeArguments.available, searchTerm = rdeArguments.searchTerm;
    return {
        alternativeProducts: "id: \"" + articleNo + "\" locale: \"" + locale + "\"",
        criteoProducts: "item: \"" + articleNo + "\" locale: \"" + locale + "\" price: " + price + " available: " + available,
        lastSeenProducts: '',
        outfit: '',
        productsSimilar: '',
        productsComplementary: '',
        prudSysAddToBasket: "cid: \"" + cid + "\"  pid: \"" + articleNo + "\" brand: \"" + brand + "\" locale: \"" + locale + "\"",
        prudsysHomePage: "locale: \"" + locale + "\"",
        prudsysCategoryToBrands: '',
        prudsysCategoryToBrandsPapi: '',
        prudsysCategoryToCategories: '',
        prudsysCategoryToCategoriesPapi: '',
        prudsysCategoryToProductsPapi: '',
        prudSysProducts: "cid: \"" + cid + "\" pid: \"" + articleNo + "\" brand: \"" + brand + "\" locale: \"" + locale + "\"",
        prudSysProductsSimilar: "cid: \"" + cid + "\" pid: \"" + articleNo + "\" brand: \"" + brand + "\" locale: \"" + locale + "\"",
        prudSysSearchTerm: "term: \"" + searchTerm + "\" locale: \"" + locale + "\" ",
        prudsysUserToProductsPapi: '',
        seriesProducts: "id: \"" + articleNo + "\" locale: \"" + locale + "\"",
    };
};
exports.default = getQueryArguments;
//# sourceMappingURL=getQueryArguments.js.map